// modules
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

// aliased
import Section from 'components/Section';
import conditions from 'data/conditions';
import SectionHeader from 'components/SectionHeader';
import StethoscopeIcon from 'components/StethoscopeIcon';
// import SearchInput from 'components/SearchInput';

// local
import styles from './ConditionsSection.pcss';

export default class ConditionsSection extends PureComponent {
  
  static propTypes = {
    className: PropTypes.string,
  }
  static defaultProps = {}
  
  render() {
    const { className } = this.props;
    
    const classNames = classnames(className, styles.conditionsSection);
    const stethoscope = (
      <StethoscopeIcon color={ 'rgba(0, 0, 0, 0.7)' } />
    );
    
    return (
      <Section id={ 'conditions' } className={ classNames }>
        <SectionHeader
          className={ styles.header }
          image={ stethoscope }
          imageClassname={ styles.icon }>
          { 'Conditions' }
        </SectionHeader>
        <p className={ styles.subTitle }>
          { 'Doctor Seideman provides complete assessment, diagnosis and treatment for:' }
        </p>
        <ul className={ styles.list }>
          {
            conditions.map((condition, i) => (
              <li key={ i } >{ condition }</li>
            ))
          }
        </ul>
      </Section>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/ConditionsSection/index.jsx